exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buttons {\r\n    padding: 15px;\r\n}\r\n\r\n.confirm-dialog {\r\n    padding: 15px;\r\n    font-size:150%;\r\n}\r\n\r\n.date-picker {\r\n    min-width:200px;\r\n    margin-left: 25%;\r\n    margin-right: 25%;\r\n    \r\n}\r\n\r\n.comments {\r\n    padding: 15px;\r\n    font-size:150%;\r\n    padding-top:25px;\r\n    min-width:470px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();